<svg class="freeway-footer-layout-social" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 16">
  <title>facebook</title>
  <path class="freeway-footer-layout-social_fill" d="M13,10h3v3H13v7H10V13H7V10h3V8.74a5.67,5.67,0,0,1,1.12-3.51A3.6,3.6,0,0,1,13.9,4H16V7H13.9a0.9,0.9,0,0,0-.9.9V10Z" transform="translate(-7 -4)"/>
</svg>
